import AuthPage from "@/components/organisms/auth-page";
import { useI18n } from "@/i18n/use-i18n";

export default function SignupPage() {
  const { t } = useI18n();
  return <AuthPage initialMode="signup" pageTitle={t("login.pageTitle")} />;
}
